var map = {
	"./10_reduced_inequalities.svg": "a7cb",
	"./10_reduced_inequalities_color.svg": "6b5a",
	"./11_sustainable_cities_and_communities.svg": "611c",
	"./11_sustainable_cities_and_communities_color.svg": "5b75",
	"./12_responsible_consumption_and_production.svg": "7dbb",
	"./12_responsible_consumption_and_production_color.svg": "9217",
	"./13_climate_action.svg": "c30c",
	"./13_climate_action_color.svg": "9d4f",
	"./14_life_below_water.svg": "6f39",
	"./14_life_below_water_color.svg": "678f",
	"./15_life_on_land.svg": "f3bb",
	"./15_life_on_land_color.svg": "c6e3",
	"./16_peace_and_justice_strong_institutions.svg": "3a66",
	"./16_peace_and_justice_strong_institutions_color.svg": "adf0",
	"./17_partnerships_to_achieve_the_goal.svg": "31ce",
	"./17_partnerships_to_achieve_the_goal_color.svg": "56b1",
	"./1_no_poverty.svg": "5f93",
	"./1_no_poverty_color.svg": "2ec2",
	"./2_zero_hunger.svg": "4cef",
	"./2_zero_hunger_color.svg": "caf4",
	"./3_good_health_and_well-being.svg": "0f08",
	"./3_good_health_and_well-being_color.svg": "c136",
	"./4_quality_education.svg": "b4bb",
	"./4_quality_education_color.svg": "4209",
	"./5_gender_equality.svg": "5cd7",
	"./5_gender_equality_color.svg": "b2b9",
	"./6_clean_water_and_sanitation.svg": "d35a",
	"./6_clean_water_and_sanitation_color.svg": "b2b1",
	"./7_affordable_and_clean_energy.svg": "ea5a",
	"./7_affordable_and_clean_energy_color.svg": "8ccc",
	"./8_decent_work_and_economic_growth.svg": "a4d4",
	"./8_decent_work_and_economic_growth_color.svg": "ce40",
	"./9_industry_innovation_and_infrastructure.svg": "38af",
	"./9_industry_innovation_and_infrastructure_color.svg": "1eff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c462";